'use client';
import {usePathname, redirect} from 'next/navigation';
import {routing} from '../src/i18n/routing';
import {LOCALE_CODES} from '../src/i18n/constants';

const retrieveLocaleFromPathname = (pathname: string) => {
  const locale = pathname.split('/')[1];
  return Object.values(LOCALE_CODES).includes(locale as LOCALE_CODES)
    ? locale
    : routing.defaultLocale;
};

export default function RootNotFound() {
  const pathname = usePathname();

  const locale = retrieveLocaleFromPathname(pathname);

  // Redirect to the default locale's not-found page
  // This handles edge cases where the middleware doesn't catch the request
  redirect(`/${locale}/not-found`);
}
